import React from 'react'
import './stylesheets/header.css'
import myimg from './digiwork-logo.png';
import { NavLink } from 'react-router-dom'

function Header() {
  return (
    <div className='main-header'>
      <div className='logo-img'>
        <img className='img' src={myimg}/>
      </div>
      <div className='webnav-menu'>
        <p><NavLink className="headernavlinks" to="/">Home</NavLink></p>
        <p><NavLink className="headernavlinks" to="/about">About</NavLink></p>
        <p><NavLink className="headernavlinks" to="/services">Services</NavLink></p>
        <p><NavLink className="headernavlinks" to="/become a seller">Become a seller</NavLink></p>
        <p><NavLink className="headernavlinks" to="/sellers">Sellers</NavLink></p>
        <p><NavLink className="headernavlinks" to="/tutorials">Tutorials</NavLink></p>
      </div>
      <div class="container h-100">
      <div class="d-flex justify-content-center h-100">
        <div class="search">
          <input class="search_input" type="text" name="" placeholder="Search here..."/>
          <a href="#" class="search_icon"><i class="fa fa-search"></i></a>
        </div>
      </div>
    </div>
    </div>
  )
}

export default Header
